// Code for social links to open in new tab

document.addEventListener("DOMContentLoaded", function () {
  const socialLinks = document.querySelectorAll('.announce_social .list-social__link');

  socialLinks.forEach(function(link) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
});


// Code for social links to open in new tab

document.addEventListener("DOMContentLoaded", function () {
  const socialLinks = document.querySelectorAll(
    '.announce_social .list-social__link, .socials a'
  );

  socialLinks.forEach(function(link) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
});